import React from "react";

function CheckedIcon() {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_25_4)">
				<path d="M10 0C11.9778 0 13.9112 0.58649 15.5557 1.6853C17.2002 2.78412 18.4819 4.3459 19.2388 6.17317C19.9957 8.00043 20.1937 10.0111 19.8079 11.9509C19.422 13.8907 18.4696 15.6725 17.0711 17.0711C15.6725 18.4696 13.8907 19.422 11.9509 19.8079C10.0111 20.1937 8.00043 19.9957 6.17317 19.2388C4.3459 18.4819 2.78412 17.2002 1.6853 15.5557C0.58649 13.9112 0 11.9778 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0V0Z" fill="#4B9CE2"/>
				<path d="M8.53989 14.428C8.2747 14.428 8.02036 14.3226 7.83286 14.135L5.55503 11.856C5.45952 11.7637 5.38332 11.6534 5.33091 11.5314C5.2785 11.4094 5.25101 11.2782 5.24985 11.1454C5.2487 11.0126 5.27379 10.881 5.32407 10.7581C5.37435 10.6352 5.44893 10.5235 5.54282 10.4296C5.63672 10.3357 5.74805 10.2615 5.87095 10.2112C5.99385 10.1609 6.12586 10.1356 6.25864 10.1368C6.39142 10.1379 6.52238 10.1655 6.64439 10.2179C6.76639 10.2703 6.87685 10.3465 6.96909 10.442L8.53989 12.014L13.9901 6.564C14.1787 6.38184 14.431 6.28105 14.6932 6.28333C14.9554 6.28561 15.2065 6.39077 15.3919 6.57618C15.5774 6.76159 15.6826 7.01241 15.6849 7.2746C15.6872 7.5368 15.5863 7.7894 15.4042 7.978L9.24693 14.135C9.05943 14.3226 8.80509 14.428 8.53989 14.428Z" fill="white"/>
			</g>
			<defs>
				<clipPath id="clip0_25_4">
					<rect width="20" height="20" fill="white"/>
				</clipPath>
			</defs>
		</svg>

	);
}

export default CheckedIcon;